import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {usersProfileArticlePerformance_template} from "./usersProfileArticlePerformance_template";
import {usersProfileRates_template} from "./usersProfileRates_template";
import {usersProfilePayment_template} from "./usersProfilePayment_template";
import {usersProfileInternalNote_template} from "./usersProfileInternalNote_template";
declare var ko: any;

export class usersProfile_template extends vnTemplate {


    public validationsList: validationsList_template;

    public articlePerformance: usersProfileArticlePerformance_template;
    public payment: usersProfilePayment_template;
    public rates: usersProfileRates_template;
    public internalNote: usersProfileInternalNote_template;

    protected getTemplateHtml(): string {

        return `
                <div class="list-header w-justify">
                    <div class="w-left">
                        <button class="btn secondary icon i-back" data-bind="css: {'is-hidden': !permissions()['users_list'] || !permissions()['users_list'].read }, event: { click: onClickUsersList}" class="user-back">Back</button>
                    </div>
                    <div class="w-right">
                        <button class="btn secondary icon i-edit" data-bind="visible: showEditBtn, click: onClickEdit" class="user-edit">Edit Profile</button>
                    </div>
                </div>
                <article class="c-user-profil">
                    <div class="c-user-picture">
                        <img class="user-img" data-bind="attr: { src: pictureUrl }">
                    </div>

                    <div class="c-user-infos">
                        <div>

                            <div data-bind="text: fullName" class="user-name"></div>
                            <div data-bind="text: email, attr: { href: 'mailto:' + email()}" class="user-email"></div>

                            <div class="user-flex user-rb">
                                <!-- ko if: company() -->
                                <div data-bind="text: company().name" class="u-role"></div>
                                <!-- /ko -->
                                <!-- ko foreach: roles -->
                                    <div data-bind="text: $data" class="u-role"></div>
                                <!-- /ko -->
                                <div data-bind="foreach: userBrands" class="u-brands">
                                    <span class="brand-item dark" data-bind="css: iconImage"></span>
                                </div>
                            </div>
                            <nav>
                                <li data-bind="event: { click: onClickLoadTab.bind($data, 'articlePerformance')}" id="u-articles">Authorship</li>
                                <li data-bind="css: {'is-hidden': !permissions()['users_profile_payments'] || !permissions()['users_profile_payments'].read  }, event: { click: onClickLoadTab.bind($data, 'payment')}" id="u-payments">Payment</li>
                                <li data-bind="css: {'is-hidden': !permissions()['users_form_rates'] || !permissions()['users_form_rates'].read }, event: { click: onClickLoadTab.bind($data, 'rates')}" id="u-rates">Rates</li>
                                <li data-bind="css: {'is-hidden': !permissions()['job_application_internal_comments']  || !permissions()['job_application_internal_comments'].read }, event: { click: onClickLoadTab.bind($data, 'internalNote')}" id="u-notes">Internal Notes</li>
                            </nav>
                        </div>
                        <div class="c-user-infos-list">
                            <ul>
                                <!-- ko if: paymentMethod -->
                                    <li><i class="fal fa-money-check-edit-alt"></i>Method : <span data-bind="text: paymentMethod"></span></li>
                                    <!-- ko if: paymentMethod() == "PayPal" && paymentEmail -->
                                        <li><i class="fab fa-paypal"></i><span data-bind="text: paymentEmail"></span></li>
                                    <!-- /ko -->
                                <!-- /ko -->
                            </ul>
                            <ul>
                                <!-- ko if: address -->
                                    <li><i class="fal fa-map-marker-alt"></i><span data-bind="text: address"></span></li>
                                <!-- /ko -->
                                <!-- ko if: city -->
                                    <li><i class="fal fa-city"></i><span data-bind="text: city"></span></li>
                                <!-- /ko -->
                                <!-- ko if: country -->
                                    <li><i class="fal fa-flag-alt"></i><span data-bind="text: country"></span></li>
                                <!-- /ko -->
                            </ul>
                        </div>
                    </div>
                </article>
                <!-- ko if: userBrands().length > 0 -->
                ${this.articlePerformance.getHtmlBuild()}
                ${this.rates.getHtmlBuild()}
                <!-- /ko -->
                ${this.payment.getHtmlBuild()}
                ${this.internalNote.getHtmlBuild()}

            `;
    }

    protected initPartial(): void {

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        this.articlePerformance = new usersProfileArticlePerformance_template("articlePerformance", this.getTemplateViewModel(), this.caller);
        this.rates = new usersProfileRates_template("rates", this.getTemplateViewModel(), this.caller);
        this.payment = new usersProfilePayment_template("payment", this.getTemplateViewModel(), this.caller);
        this.internalNote = new usersProfileInternalNote_template("internalNotes", this.getTemplateViewModel(), this.caller);

    }

    protected getTemplateName(): string {
        return "usersProfile-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [""];
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            id: ko.observable(""),
            user: ko.observableArray([]),
            loggedUser: ko.observableArray([]),
            userBrands: ko.observableArray([]),
            idUser: ko.observable(""),
            loginName: ko.observable(""),
            fullName: ko.observable(""),
            email: ko.observable(""),
            pictureUrl: ko.observable("/assets/images/default-user.png"),
            paymentMethod: ko.observable(""),
            paymentEmail: ko.observable(""),
            currency: ko.observable(""),
            brandsIcons: ko.observableArray([]),
            roles: ko.observable([]),
            address: ko.observable(""),
            city: ko.observable(""),
            country: ko.observable(""),
            showEditBtn: ko.observable(true),
            permissions: ko.observableArray(this.initPermissions(['users_form_rates','users_list', 'users_profile_payments', 'users_form_general_manager'])),
            isLoading: ko.observable(0),
            company: ko.observableArray([]),
            loggedUserRoles : ko.observable([]),

            onClickEdit:  (data, event) => {
                self.onClickEdit(data.id)
            },
            onClickLoadTab: (data, event) => {
                self.onClickLoadTab(data);
            },
            onClickUsersList: (data, event) => {
                self.onClickUsersList();
            }
        }
    }

    public onClickLoadTab(tab) {

        this.articlePerformance.setVisible(false);
        this.rates.setVisible(false);
        this.payment.setVisible(false);
        this.internalNote.setVisible(false);

        this[tab].setVisible(true);
        if (this[tab].getTemplateViewModel().hasData() != true) {

            this.caller.getData(tab);
        }
    }


    public onClickEdit(id) {
        this.caller.editUser(id);
    }

    public onClickUsersList() {
        this.caller.usersList();
    }

    public setUser(user: any) {
        this.getTemplateViewModel().user(user);
        this.getTemplateViewModel().userBrands(user.brands)

        this.setLoginName(user.valnet_user.loginName)
        this.setFullName(user.valnet_user.fullName)
        if (user.valnet_user.pictureUrl) {

            this.setPictureUrl(user.valnet_user.pictureUrl)
        }

        if (user.valnet_paymentInfo && user.valnet_paymentInfo.currency) {

            this.setCurrency(user.valnet_paymentInfo.currency.currency)
        }
        this.setEmail(user.valnet_user.email)
        let roles = [];
        for (let role of user.valnet_user.roles) {

            roles.push(role.name);
        }
        this.setRoles(roles);

        if (user.valnet_paymentInfo && user.valnet_paymentInfo.method) {

            this.setPaymentMethod(user.valnet_paymentInfo.method.name);
        }else{
            this.setPaymentMethod("None");
        }

        if (user.valnet_paymentInfo) {

            this.setPaymentEmail(user.valnet_paymentInfo.email);
        }

        if (user.valnet_user) {

            this.setAddress(user.valnet_user.address);
        }

        if (user.valnet_user) {

            this.setCity(user.valnet_user.city);
        }

        if (user.valnet_user && user.valnet_user.country) {

            this.setCountry(user.valnet_user.country.name);
        }

        let userRoles = this.getTemplateViewModel().roles()
        let loggedUserRoles = this.getTemplateViewModel().loggedUserRoles()

        if(userRoles.includes('Payroll Accountant') && loggedUserRoles.includes('Payroll Accountant')){
            if(!this.getTemplateViewModel().permissions()['users_form_general_manager'].read) {
                this.getTemplateViewModel().showEditBtn(false)
            }
        }

    }


    public setUserId(idUser) {
        this.getTemplateViewModel().idUser(idUser);
    }

    public setLoginName(loginName) {
        this.getTemplateViewModel().loginName(loginName);
    }

    public setAddress(address) {
        this.getTemplateViewModel().address(address);
    }

    public setCity(city) {
        this.getTemplateViewModel().city(city);
    }

    public setCountry(country) {
        this.getTemplateViewModel().country(country);
    }

    public setFullName(fullName) {
        this.getTemplateViewModel().fullName(fullName);
    }

    public setPictureUrl(pictureUrl) {
        this.getTemplateViewModel().pictureUrl(pictureUrl);
    }

    public setEmail(email) {
        this.getTemplateViewModel().email(email);
    }

    public setPaymentMethod(paymentMethod) {
        this.getTemplateViewModel().paymentMethod(paymentMethod);
    }

    public setPaymentEmail(paymentEmail) {

        this.getTemplateViewModel().paymentEmail(paymentEmail);
    }

    public setRoles(roles) {
        this.getTemplateViewModel().roles(roles);
    }

    public setChannelIcons(brandIcons) {
        this.getTemplateViewModel().brandIcons(brandIcons);
    }

    public setCurrency(currency) {
        this.getTemplateViewModel().currency(currency);
    }

    public setShowEditBtn() {

    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

    public getFullName(): string {
        return this.getTemplateViewModel().fullName();
    }

    public setCompany(company){

        this.getTemplateViewModel().company(company);
    }

    public hideDailyViewsChart(): void {
        this.articlePerformance.hideDailyViewsChart();
    }

    public showDailyViewsChart(): void {
        this.articlePerformance.showDailyViewsChart();
    }

    public isLoading(flag): void {
        this.getTemplateViewModel().isLoading(flag);
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/usersProfile_template.ts